import { useCallback } from 'react';
import { mutate } from 'swr';

import { OVERRIDE_VISIT_AUTO_CANCEL_MUTATION } from 'src/components/pages/pageElements/videoConference/useOverrideVisitAutoCancel.gql';
import { VISIT_AUTO_CANCEL_INFO_QUERY } from 'src/components/pages/pageElements/videoConference/useSWRVisitAutoCancelInfo.gql';
import useApolloClient from 'src/shared/client/useApolloClient';

export const useOverrideVisitAutoCancel = () => {
  const apolloClient = useApolloClient();

  const overrideVisitAutoCancel = useCallback(
    async (eventId: string) => {
      try {
        await apolloClient.mutate({
          mutation: OVERRIDE_VISIT_AUTO_CANCEL_MUTATION,
          variables: { eventId },
        });

        // Invalidate the SWR cache for this specific event's auto-cancel info
        // This will cause the query to re-fetch and show the updated state
        await mutate([VISIT_AUTO_CANCEL_INFO_QUERY, { eventId }]);

        return { success: true };
      } catch (error) {
        console.error('Error overriding visit auto-cancel:', error);
        return { success: false, error };
      }
    },
    [apolloClient],
  );

  return {
    overrideVisitAutoCancel,
  };
};
